<template>
    <svg fill="#48B6E7" height="17" viewBox="0 0 14 15" width="23" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.673 12.834v1.968H.254v-1.969c0-.93.802-2.074 1.78-2.54l2.18-1.034 1.512 3.152.774-2.1c.153.029.304.067.464.067.159 0 .31-.038.463-.067l.735 1.996 1.483-3.083 2.249 1.07c.978.465 1.78 1.61 1.78 2.54zm-11.44-6.9V4.51c0-.24.126-.452.315-.574A4.452 4.452 0 0 1 6.965 0a4.453 4.453 0 0 1 4.417 3.938.682.682 0 0 1 .314.573v1.422a.684.684 0 1 1-1.367 0v-.298c-.37 1.861-1.733 3.59-3.364 3.59-1.63 0-2.993-1.729-3.363-3.59v.298a.682.682 0 0 1-.482.65 3.99 3.99 0 0 0 1.71 2.251.697.697 0 0 1 .537.057c.303.158.457.464.342.683-.114.219-.452.268-.756.11-.222-.116-.363-.311-.378-.493a4.432 4.432 0 0 1-1.912-2.624.683.683 0 0 1-.43-.634zm.781-2.156c.02.001.04.002.06.009.05.018.086.054.11.095a.681.681 0 0 1 .34.321c.201-1.89 1.663-2.89 3.44-2.89s3.238 1 3.44 2.89c.1-.196.29-.337.518-.366a4.013 4.013 0 0 0-3.958-3.4 4.014 4.014 0 0 0-3.95 3.34z"
            fill-rule="nonzero"
        />
    </svg>
</template>
<script>
export default {
    name: "Representative",
};
</script>
